export default __webpack_public_path__ + "static/media/login.adaef383.svg";